import moment from "moment";
import React, { Component, useEffect, useState } from "react";
import GantChart from "../components/GanttChart/GanttChart";
import GanttList from "../components/GanttChart/GanttList";
import { buildGantt } from "../components/GanttChart/DateBuilder";
import { v4 as uuid } from "uuid";
import { getBoundingClientRect } from "../utils/functions";
import { translate } from "../../src/utils/useful"
import FixedView from "../components/FixedView";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import * as actions from "../stores/actionsList"
class GanttWindow extends Component {

    contextMenu = React.createRef();
    firstView = React.createRef();
    firstCurrentNode = React.createRef();
    sortView = React.createRef();
    sortCurrentNode = React.createRef();

    state = {
        structure: "Set Structure",
        date: [],
        ganttChartView: "Week/Day",
        showStructureList: false,
        count: 7,
        momentDate: moment(),
        scrollRight: 0,
        tasks: [],
        holderWidth: 0,
        hoveredId: null,
        showMonthList: false,
        showGanttList: true,

        TimeStructure: [
            { name: "Day/Hour", view: "Day/Hour", count: 35 },
            { name: "Week/Day", view: "Week/Day", count: 7 },
            { name: "Month/Day", view: "Month/Day", count: 35 },
            { name: "Year/Month", view: "Year/Month", count: 35 },
            { name: "Year", view: "Year", count: 35 },
        ],
        sortby: ['Date created', 'Date updated', 'Name', 'Priority', 'Start date']

    }

    // addNewTask = (taskName, taskDesc) => {
    //     let newtask = { id: uuid(), taskName, taskDesc, startDay: '', endDay: '' };
    //     let tasks = [...this.state.tasks];
    //     tasks.push(newtask)
    //     this.setState({ tasks })
    // };
    changeTaskTimeStamp = () => {

    }
    setTaskTimestamp = (taskId, startDay, endDay) => {
        let tasks = [...this.props.inbox.desk];
        let foundTask = tasks.find(task => task.id === taskId);
        foundTask.startDay = startDay;
        foundTask.endDay = endDay;
        this.setState({ tasks }, () => {
            // console.log(this.props.inbox.desk, "hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
        })
    }
    showMonth = () => {

        this.setState({
            showMonthList: !this.state.showMonthList
        })
    }

    // setData = (key, value) => {
    //     this.setState({[key]:value})
    // }
    prevMonth = () => {
        console.log("prevmonth")
        setTimeout(() => {
            // this.changeWidth()
        }, 100);
        this.setState({ date: buildGantt(this.state.momentDate, this.state.count), title: this.props.title, today: new Date().getTime() }, () => {
        });
        switch (this.state.ganttChartView) {
            case "Week/Day":
                this.setState({
                    date: buildGantt(this.state.momentDate.subtract(1, 'week'), 7)
                })
            case "Day/Hour":
                this.setState({

                    date: buildGantt(this.state.momentDate.subtract(1, 'day'), 35)

                })
            case "Month/Day":
                this.setState({

                    date: buildGantt(this.state.momentDate.subtract(1, 'month'), 35)

                })
            case "Year/Month" || "year":
                this.setState({

                    date: buildGantt(this.state.momentDate.subtract(1, 'year'), 35)

                })
            // case "Year":
            //     this.setState({

            //         date: buildGantt(this.state.momentDate.subtract(1, 'year'), 35)

            //     })
        }
    }
    nextMonth = () => {
        console.log(this.state.ganttChartView)
        setTimeout(() => {
            // this.changeWidth()
        }, 100);
        this.setState({ date: buildGantt(this.state.momentDate, this.state.count), title: this.props.title, today: new Date().getTime() }, () => {
        });

        switch (this.state.ganttChartView) {
            case "Week/Day":
                this.setState({
                    date: buildGantt(this.state.momentDate.add(1, 'month'), 7)
                })
            case "Day/Hour":
                this.setState({

                    date: buildGantt(this.state.momentDate.add(1, 'day'), 35)
                })
            case "Month/Day":
                this.setState({

                    date: buildGantt(this.state.momentDate.add(1, 'month'), 35)
                })
            case "Year/Month":
                this.setState({

                    date: buildGantt(this.state.momentDate.add(1, 'year'), 35)
                })
            case "Year":
                this.setState({

                    date: buildGantt(this.state.momentDate.add(1, 'year'), 35)
                })


        }

    }
    setStructure = () => {
        this.firstView.showView()
    }
    componentDidMount() {
        setTimeout(() => {
            this.changeWidth()
        }, 100);
        this.setState({ date: buildGantt(this.state.momentDate, this.state.count), title: this.props.title, today: new Date().getTime() }, () => {
        });
    }
    componentWillUnmount() {
    }
    render() {
        let weekDaysName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        let { date, holderWidth, tasks, hoveredId } = this.state;

        return (
            <div style={{ background: "white" }} >
                <div className="task-nav flexcb">
                    <div className="task-nav-search flexcc" >
                        <img src="/assets/icons/gantt/search.svg" />
                        <input type="search" name="name" placeholder="Search tasks ..." />
                    </div>
                    <div className="task-nav-buttons">
                        <div className="task-nav-button cursor-poiner" ref={el => this.sortCurrentNode = el} onClick={() => this.sortView.showView()}>
                            <img src="/assets/icons/gantt/sort.svg" />
                            Sort by
                        </div>
                        <div className="task-nav-button cursor-poiner" ref={el => this.firstCurrentNode = el} onClick={() => this.setStructure()}>
                            <img src="/assets/icons/gantt/deskclock.svg" />
                            {this.state.structure}
                        </div>
                        <div className="task-nav-button cursor-poiner">
                            <img src="/assets/icons/gantt/today-tasks.svg" />
                            Today tasks
                        </div>
                    </div>
                </div>


                <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={-20} zIndex={10}>

                    <div className="time-structure-list shadow-2 br-10 py-1 px-2">

                        {this.state.TimeStructure.map((prop, index) => {
                            return (
                                <>
                                    <div className='time-structure-option px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' onClick={() => {
                                        this.setState({ date: buildGantt(this.state.momentDate, prop.count), ganttChartView: prop.view, structure: prop.view })

                                        this.firstView.hideView()
                                    }
                                    }>
                                        <p>
                                            {prop.name}
                                        </p>
                                    </div>

                                </>
                            )
                        })}

                    </div></FixedView>

                <FixedView ref={el => this.sortView = el} nodeRef={this.sortCurrentNode} showFocus={false} topOffset={-70} xOffset={-280} zIndex={10}>

                    <div className="sort-context-menu  shadow-2 br-10 py-1 px-2" style={this.props.style} >
                        {this.state.sortby.map((item, index) => {
                            return (
                                <button className="px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5">
                                    <p>{translate(item)}</p>
                                </button>
                            )
                        })}

                    </div>
                </FixedView>
                <div
                    className="GanttWindow "
                    onScroll={() => this.onScroll}
                    id="gantt-holder"
                    ref={el => this.GanttWindowRef = el}
                    style={{ overflowX: "scroll", minHeight: "700px" }}
                >
                    <div
                        className="left-0"
                        style={{ position: "sticky", zIndex: "1", background: "white" }}
                    >
                        <div className="close-button" onClick={() => this.setState({ showGanttList: !this.state.showGanttList, angle: !this.state.angle })}>
                            <img src={this.state.angle == false ? "/assets/icons/gantt/angle-left.svg" : "/assets/icons/gantt/angle-right.svg"} alt="" width="12" height="12" style={{ opacity: '50%' }} />
                        </div>
                        {this.state.showGanttList ?
                            <GanttList
                                showMonth={this.showMonth}
                                tasks={tasks}
                                hoveredId={hoveredId}
                                prevMonth={this.prevMonth}
                                nextMonth={this.nextMonth}
                                date={date}
                                setData={this.setData}
                            />
                            :
                            null
                        }
                    </div>
                    <div className="" style={{ display: "flex", flexDirection: "column" }}>
                        <GantChart
                            setTaskTimestamp={this.setTaskTimestamp}
                            date={date}
                            setData={this.setData}
                            prevMonth={this.prevMonth}
                            nextMonth={this.nextMonth}
                            weekDaysName={weekDaysName}
                            tasks={tasks}
                            ganttChartView={this.state.ganttChartView}
                            holderWidth={holderWidth}
                            showRowShadow={this.state.showRowShadow}
                            changeTaskTimeStamp={this.changeTaskTimeStamp}
                            setHoveredId={(hoveredId) => this.setState({ hoveredId })}
                            windowRect={getBoundingClientRect(this.GanttWindowRef)}
                        />
                        {/* <NewTask addNewTask={this.addNewTask} /> */}
                    </div>
                </div></div>
        );
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GanttWindow);